<section class="employee-import">
  <div class="employee-import__header">
    <div class="employee-import__heading">
      <span class="employee-import__icon"><mat-icon>group_add</mat-icon></span>
      <div class="employee-import__header-copy">
        <span class="employee-import__eyebrow">{{ 'employeesCatalog.import.eyebrow' | translate }}</span>
        <h2>{{ 'employeesCatalog.import.title' | translate }}</h2>
        <p>{{ 'employeesCatalog.import.description' | translate }}</p>
      </div>
    </div>
    <button type="button" mat-icon-button [attr.aria-label]="'common.close' | translate" (click)="close()" [disabled]="isImporting">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <nav class="employee-import__steps" [attr.aria-label]="'employeesCatalog.import.steps.label' | translate">
    <div class="employee-import__step" [class.is-active]="step === 'file'" [class.is-complete]="step !== 'file'">
      <span class="employee-import__step-marker">@if (step !== 'file') { <mat-icon>check</mat-icon> } @else { 1 }</span>
      <span class="employee-import__step-copy"><strong>{{ 'employeesCatalog.import.steps.file' | translate }}</strong><small>{{ 'employeesCatalog.import.steps.fileHint' | translate }}</small></span>
    </div>
    <div class="employee-import__step" [class.is-active]="step === 'organization'" [class.is-complete]="step === 'result'">
      <span class="employee-import__step-marker">@if (step === 'result') { <mat-icon>check</mat-icon> } @else { 2 }</span>
      <span class="employee-import__step-copy"><strong>{{ 'employeesCatalog.import.steps.organization' | translate }}</strong><small>{{ 'employeesCatalog.import.steps.organizationHint' | translate }}</small></span>
    </div>
    <div class="employee-import__step" [class.is-active]="step === 'result'">
      <span class="employee-import__step-marker">3</span>
      <span class="employee-import__step-copy"><strong>{{ 'employeesCatalog.import.steps.result' | translate }}</strong><small>{{ 'employeesCatalog.import.steps.resultHint' | translate }}</small></span>
    </div>
  </nav>

  <mat-dialog-content class="employee-import__content">
    @if (step === 'file') {
      <div class="employee-import__toolbar" [class.is-compact]="rows.length > 0">
        <div>
          <h3>{{ 'employeesCatalog.import.file.title' | translate }}</h3>
          <p>{{ 'employeesCatalog.import.file.description' | translate }}</p>
        </div>
        <button type="button" mat-stroked-button class="employee-import__template-action" (click)="downloadTemplate()">
          <mat-icon>download</mat-icon>
          {{ 'employeesCatalog.import.file.downloadTemplate' | translate }}
        </button>
      </div>

      @if (!rows.length) {
        <div class="employee-import__file-stage">
          <label class="employee-import__dropzone" [class.has-error]="!!fileError">
            <input type="file" accept=".xlsx,.xls" (change)="onFileSelected($event)" [disabled]="isReading">
            @if (isReading) {
              <span class="employee-import__upload-icon"><mat-spinner diameter="30"></mat-spinner></span>
              <strong>{{ 'employeesCatalog.import.file.reading' | translate }}</strong>
            } @else {
              <span class="employee-import__upload-visual" aria-hidden="true">
                <i class="employee-import__orbit employee-import__orbit--one"></i>
                <i class="employee-import__orbit employee-import__orbit--two"></i>
                <span class="employee-import__upload-icon"><mat-icon>upload_file</mat-icon></span>
              </span>
              <strong>{{ 'employeesCatalog.import.file.select' | translate }}</strong>
              <span>{{ 'employeesCatalog.import.file.hint' | translate }}</span>
              <em>{{ 'employeesCatalog.import.file.browse' | translate }}</em>
            }
          </label>

          <div class="employee-import__recognized-fields">
            <div class="employee-import__recognized-copy">
              <span><mat-icon>verified</mat-icon></span>
              <div>
                <strong>{{ 'employeesCatalog.import.file.recognizedFields' | translate }}</strong>
                <small>{{ 'employeesCatalog.import.file.recognizedHint' | translate }}</small>
              </div>
            </div>
            <div class="employee-import__field-list">
              <span>{{ 'employeesCatalog.fields.employeeNumber' | translate }}</span>
              <span>{{ 'employeesCatalog.fields.firstName' | translate }}</span>
              <span>{{ 'employeesCatalog.fields.lastName' | translate }}</span>
              <span>{{ 'employeesCatalog.fields.secondLastName' | translate }}</span>
              <span>{{ 'employeesCatalog.fields.email' | translate }}</span>
              <span class="employee-import__date-field">
                {{ 'employeesCatalog.fields.hireDate' | translate }}
                <small>DD-MM-YYYY / DD/MM/YYYY</small>
              </span>
              <span>{{ 'employeesCatalog.import.credentials.password' | translate }}</span>
              <span>{{ 'employeesCatalog.import.organization.orgUnitCode' | translate }}</span>
            </div>
          </div>
        </div>
      } @else {
        <div class="employee-import__file-ready">
          <span class="employee-import__file-ready-icon"><mat-icon>description</mat-icon></span>
          <div class="employee-import__file-ready-copy">
            <strong>{{ fileName }}</strong>
            <small>{{ 'employeesCatalog.import.file.ready' | translate }}</small>
          </div>
          <div class="employee-import__file-metrics">
            <span><small>{{ 'employeesCatalog.import.summary.total' | translate }}</small><strong>{{ rows.length }}</strong></span>
            <span class="is-success"><small>{{ 'employeesCatalog.import.summary.valid' | translate }}</small><strong>{{ rows.length - invalidRows.length }}</strong></span>
            <span class="is-error"><small>{{ 'employeesCatalog.import.summary.invalid' | translate }}</small><strong>{{ invalidRows.length }}</strong></span>
          </div>
          <label class="employee-import__replace-file">
            <input type="file" accept=".xlsx,.xls" (change)="onFileSelected($event)" [disabled]="isReading">
            <mat-icon>sync</mat-icon>{{ 'employeesCatalog.import.file.replace' | translate }}
          </label>
        </div>
      }

      @if (fileError) {
        <div class="employee-import__alert employee-import__alert--error"><mat-icon>error</mat-icon><span>{{ fileError }}</span></div>
      }

      @if (rows.length) {
        <div class="employee-import__table-shell employee-import__table-shell--file">
          <table class="employee-import__table">
            <thead><tr>
              <th>{{ 'employeesCatalog.import.columns.row' | translate }}</th>
              <th>{{ 'employeesCatalog.fields.employeeNumber' | translate }}</th>
              <th>{{ 'employeesCatalog.fields.fullName' | translate }}</th>
              <th>{{ 'employeesCatalog.fields.email' | translate }}</th>
              <th>{{ 'employeesCatalog.fields.hireDate' | translate }}</th>
              <th>{{ 'employeesCatalog.import.columns.validation' | translate }}</th>
            </tr></thead>
            <tbody>
              @for (row of rows; track row.rowNumber) {
                <tr [class.has-error]="row.errors.length">
                  <td>{{ row.rowNumber }}</td>
                  <td>{{ row.employeeNumber || '—' }}</td>
                  <td><strong>{{ row.firstName }} {{ row.lastName }} {{ row.secondLastName }}</strong></td>
                  <td>{{ row.email || '—' }}</td>
                  <td>{{ row.hireDate ? formatHireDateForDisplay(row.hireDate) : '—' }}</td>
                  <td>
                    @if (row.errors.length) {
                      <span class="employee-import__status is-error"><mat-icon>error</mat-icon>{{ row.errors.join(' · ') }}</span>
                    } @else {
                      <span class="employee-import__status is-success"><mat-icon>check_circle</mat-icon>{{ 'employeesCatalog.import.status.valid' | translate }}</span>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    }

    @if (step === 'organization') {
      <div class="employee-import__view">
        <div class="employee-import__toolbar">
          <div>
            <h3>{{ 'employeesCatalog.import.organization.title' | translate }}</h3>
            <p>{{ 'employeesCatalog.import.organization.description' | translate:{ count: rows.length } }}</p>
          </div>
        </div>

        <section class="employee-import__destination-card" [attr.aria-label]="'employeesCatalog.import.organization.targetTitle' | translate">
          <div class="employee-import__assignment-flow employee-import__assignment-flow--company">
            <div class="employee-import__assignment-field" [class.has-value]="!!selectedCompanyId">
              <span class="employee-import__field-caption">{{ 'employeesCatalog.fields.company' | translate }}</span>
              <app-company-select [records]="data.companies" [value]="selectedCompanyId"
                                  [label]="'employeesCatalog.fields.company' | translate"
                                  [placeholder]="'employeesCatalog.import.organization.selectCompany' | translate"
                                  [searchPlaceholder]="'employeesCatalog.import.organization.searchCompany' | translate"
                                  (valueChange)="selectedCompanyId = $event; onCompanyChange()" />
            </div>

            <div class="employee-import__assignment-explanation">
              <span><mat-icon>account_tree</mat-icon></span>
              <div>
                <strong>{{ 'employeesCatalog.import.organization.perRowTitle' | translate }}</strong>
                <small>{{ 'employeesCatalog.import.organization.perRowHint' | translate }}</small>
              </div>
            </div>
          </div>

          @if (selectedCompanyId) {
            <div class="employee-import__assignment-ready" [class.has-pending]="pendingOrgUnitRows.length > 0">
              <mat-icon>{{ pendingOrgUnitRows.length ? 'pending' : 'check_circle' }}</mat-icon>
              <span>{{ pendingOrgUnitRows.length ? ('employeesCatalog.import.organization.pendingRows' | translate:{ count: pendingOrgUnitRows.length }) : ('employeesCatalog.import.organization.allRowsAssigned' | translate) }}</span>
            </div>
          }

        </section>

        @if (importError) {
          <div class="employee-import__alert employee-import__alert--error"><mat-icon>error</mat-icon><span>{{ importError }}</span></div>
        }

        <section class="employee-import__preview-card">
          <div class="employee-import__preview-heading">
            <div class="employee-import__preview-title">
              <span><mat-icon>description</mat-icon></span>
              <div>
              <strong>{{ 'employeesCatalog.import.organization.previewTitle' | translate }}</strong>
              <small>{{ fileName }}</small>
              </div>
            </div>
            <div class="employee-import__preview-metrics">
              <span><small>{{ 'employeesCatalog.import.summary.total' | translate }}</small><strong>{{ rows.length }}</strong></span>
              <span class="is-valid"><small>{{ 'employeesCatalog.import.summary.valid' | translate }}</small><strong>{{ rows.length - invalidRows.length }}</strong></span>
              <span [class.has-errors]="invalidRows.length"><small>{{ 'employeesCatalog.import.summary.invalid' | translate }}</small><strong>{{ invalidRows.length }}</strong></span>
            </div>
          </div>

          <div class="employee-import__table-shell employee-import__table-shell--assignment">
            <table class="employee-import__table">
              <thead><tr>
                <th>{{ 'employeesCatalog.import.columns.row' | translate }}</th>
                <th>{{ 'employeesCatalog.fields.employeeNumber' | translate }}</th>
                <th>{{ 'employeesCatalog.fields.fullName' | translate }}</th>
                <th>{{ 'employeesCatalog.fields.email' | translate }}</th>
                <th>{{ 'employeesCatalog.fields.hireDate' | translate }}</th>
                <th>{{ 'employeesCatalog.fields.orgUnit' | translate }}</th>
              </tr></thead>
              <tbody>
                @for (row of rows; track row.rowNumber) {
                  <tr>
                    <td><span class="employee-import__row-number">{{ row.rowNumber }}</span></td>
                    <td>{{ row.employeeNumber || ('employeesCatalog.import.status.automatic' | translate) }}</td>
                    <td><span class="employee-import__employee-cell"><i>{{ row.firstName.charAt(0) }}</i><strong>{{ row.firstName }} {{ row.lastName }} {{ row.secondLastName }}</strong></span></td>
                    <td>{{ row.email || '—' }}</td>
                    <td>{{ row.hireDate }}</td>
                    <td class="employee-import__org-unit-cell">
                      @if (row.orgUnitResolvedFromCode) {
                        <span class="employee-import__resolved-unit">
                          <mat-icon>check_circle</mat-icon>
                          <span><strong>{{ getOrgUnitName(row.orgUnitId) }}</strong><small>{{ getOrgUnitCode(row.orgUnitId) }}</small></span>
                        </span>
                      } @else {
                        @if (row.orgUnitCode && !row.orgUnitId) {
                          <small class="employee-import__unresolved-code">{{ 'employeesCatalog.import.organization.codeNotFound' | translate:{ code: row.orgUnitCode } }}</small>
                        }
                        <button type="button"
                                class="employee-import__org-unit-picker-button"
                                [class.has-selection]="!!row.orgUnitId"
                                [disabled]="!selectedCompanyId"
                                (click)="openOrgUnitPicker(row)">
                          <mat-icon>account_tree</mat-icon>
                          <span>
                            {{ row.orgUnitId
                              ? getOrgUnitPath(row.orgUnitId)
                              : ((selectedCompanyId
                                ? 'employeesCatalog.import.organization.selectRowOrgUnit'
                                : 'employeesCatalog.import.organization.selectCompanyFirst') | translate) }}
                          </span>
                          <mat-icon>chevron_right</mat-icon>
                        </button>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </section>
      </div>
    }

    @if (step === 'result' && importResponse) {
      <div class="employee-import__view employee-import__result-view">
        <div class="employee-import__result-heading">
          <span class="employee-import__result-icon" [class.has-errors]="importResponse.summary.failed > 0"><mat-icon>{{ importResponse.summary.failed ? 'rule' : 'check_circle' }}</mat-icon></span>
          <h3>{{ 'employeesCatalog.import.result.title' | translate }}</h3>
        </div>
        <div class="employee-import__summary">
          <div><span>{{ 'employeesCatalog.import.summary.total' | translate }}</span><strong>{{ importResponse.summary.total }}</strong></div>
          <div class="is-success"><span>{{ 'employeesCatalog.import.summary.created' | translate }}</span><strong>{{ importResponse.summary.created }}</strong></div>
          <div class="is-error"><span>{{ 'employeesCatalog.import.summary.failed' | translate }}</span><strong>{{ importResponse.summary.failed }}</strong></div>
        </div>
        @if (generatedCredentials.length) {
          <section class="employee-import__credentials">
            <div class="employee-import__credentials-header">
              <div>
                <span class="employee-import__credentials-icon"><mat-icon>password</mat-icon></span>
                <div>
                  <strong>{{ 'employeesCatalog.import.credentials.title' | translate }}</strong>
                  <p>{{ 'employeesCatalog.import.credentials.description' | translate }}</p>
                </div>
              </div>
              <div class="employee-import__credentials-actions">
                <button type="button" mat-stroked-button (click)="copyAllGeneratedCredentials()" [disabled]="!hasCopyableGeneratedCredentials">
                  <mat-icon>content_copy</mat-icon>{{ 'employeesCatalog.import.credentials.copyAll' | translate }}
                </button>
                <button type="button" mat-flat-button class="employee-import__primary-button" (click)="downloadGeneratedCredentials()" [disabled]="!hasCopyableGeneratedCredentials">
                  <mat-icon>download</mat-icon>{{ 'employeesCatalog.import.credentials.download' | translate }}
                </button>
              </div>
            </div>
          </section>
        }
        <div class="employee-import__table-shell employee-import__table-shell--result">
          <table class="employee-import__table">
            <thead><tr>
              <th>{{ 'employeesCatalog.import.columns.row' | translate }}</th>
              <th>{{ 'employeesCatalog.fields.employeeNumber' | translate }}</th>
              <th>{{ 'employeesCatalog.fields.fullName' | translate }}</th>
              <th>{{ 'employeesCatalog.fields.email' | translate }}</th>
              <th>{{ 'employeesCatalog.import.columns.result' | translate }}</th>
              <th>{{ 'employeesCatalog.import.credentials.password' | translate }}</th>
              <th>{{ 'employeesCatalog.import.columns.detail' | translate }}</th>
            </tr></thead>
            <tbody>
              @for (result of importResponse.results; track result.rowNumber) {
                <tr [class.has-error]="result.status === 'failed'">
                  <td>{{ getImportDisplayRowNumber(result) }}</td>
                  <td>{{ result.employeeNumber || '—' }}</td>
                  <td><strong>{{ getImportEmployeeFullName(result) }}</strong></td>
                  <td>{{ getImportEmployeeEmail(result) }}</td>
                  <td><span class="employee-import__status" [class.is-success]="result.status === 'created'" [class.is-error]="result.status === 'failed'"><mat-icon>{{ result.status === 'created' ? 'check_circle' : 'error' }}</mat-icon>{{ result.status === 'created' ? ('employeesCatalog.import.status.created' | translate) : ('employeesCatalog.import.status.failed' | translate) }}</span></td>
                  <td>
                    @if (getGeneratedCredential(result); as credential) {
                      <div class="employee-import__credential-secret">
                        <code>{{ credential.temporaryPassword }}</code>
                        <button type="button" mat-icon-button [attr.aria-label]="'employeesCatalog.import.credentials.copy' | translate" (click)="copyGeneratedCredential(credential)">
                          <mat-icon>{{ credential.copied ? 'check' : 'content_copy' }}</mat-icon>
                        </button>
                      </div>
                    } @else {
                      —
                    }
                  </td>
                  <td>
                    @if (result.errors.length) {
                      <div class="employee-import__errors">
                        @for (error of result.errors; track $index) {
                          <div class="employee-import__error-item">
                            <div class="employee-import__error-meta">
                              <code>{{ error.code }}</code>
                              @if (error.field) { <span>{{ getImportErrorFieldLabel(error.field) }}</span> }
                            </div>
                            <span>{{ getImportErrorMessage(error) }}</span>
                          </div>
                        }
                      </div>
                    } @else {
                      {{ 'employeesCatalog.import.status.noErrors' | translate }}
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="employee-import__actions">
    @if (step === 'organization') {
      <div class="employee-import__footer-summary" [class.is-ready]="isOrganizationReady">
        <strong>{{ isOrganizationReady ? ('employeesCatalog.import.organization.readyToImport' | translate) : ('employeesCatalog.import.organization.pendingAssignment' | translate) }}</strong>
        <span>{{ isOrganizationReady ? ('employeesCatalog.import.organization.footerReady' | translate:{ count: rows.length }) : ('employeesCatalog.import.organization.footerPending' | translate) }}</span>
      </div>
    }
    <span class="employee-import__actions-spacer"></span>
    @if (step === 'file') {
      <button type="button" mat-stroked-button class="employee-import__secondary-button" (click)="close()">{{ 'common.cancel' | translate }}</button>
      <button type="button" mat-flat-button class="employee-import__primary-button" [disabled]="!canContinue" (click)="continueToOrganization()">
        {{ 'employeesCatalog.import.actions.continue' | translate }}<mat-icon>arrow_forward</mat-icon>
      </button>
    } @else if (step === 'organization') {
      <button type="button" mat-stroked-button class="employee-import__secondary-button" (click)="backToFile()" [disabled]="isImporting"><mat-icon>arrow_back</mat-icon>{{ 'common.back' | translate }}</button>
      <button type="button" mat-flat-button class="employee-import__primary-button" [disabled]="!canImport" (click)="importEmployees()">
        @if (isImporting) { <mat-spinner diameter="20"></mat-spinner> } @else { <mat-icon>group_add</mat-icon> }
        {{ 'employeesCatalog.import.actions.import' | translate:{ count: rows.length } }}
      </button>
    } @else {
      <button type="button" mat-flat-button class="employee-import__primary-button" (click)="close()">{{ 'employeesCatalog.import.actions.finish' | translate }}</button>
    }
  </mat-dialog-actions>
</section>
